export default new class SubscriptionTable {
    constructor() {
      this.holderClass = '.price-table__cell';
      this.buttonClass = '.subscription-card__btn';
      this.resultClass = '.subscription-select-result';
  
      if (!document.querySelector(this.holderClass)) return;
      this.init();
    }
  
    init() {
        let subscriptionBtns = document.querySelectorAll(this.buttonClass)
        subscriptionBtns.forEach(btn => {
            btn.addEventListener('click', (event) => {
                const obWrapper = $(event.target).parents(this.holderClass);
                const obResult = obWrapper.find(`${this.resultClass}`);
                const iProductID = obResult.attr('data-product-id');
                const iPeriodID = obResult.attr('data-period-id');
                const sJournal = obResult.attr('data-journal');
                const sSubJournal = obResult.attr('data-subjournal');
                const obRequest = { with_redirect: 1 };
          
                obRequest[`product_id_${sSubJournal}`] = iProductID;
                obRequest[`period_id_${sSubJournal}`] = iPeriodID;
                obRequest[`journal_${sSubJournal}`] = sJournal;
                obRequest[`subjournal_${sSubJournal}`] = sSubJournal;
                obRequest[`cart_position_${sSubJournal}`] = 1;
          
                $.request('Cart::onCustomSync', {
                  data: obRequest,
                });
            });
        })      
    }
  }();